import { LinkIcon } from "@src/assets";
import { Chain } from "@src/models";

type Props = {
  chain: Chain;
  isSelected?: boolean;
  onClick: () => void;
};

export const ChainItem = ({ chain, onClick, isSelected = false }: Props) => {
  return (
    <button
      className={`w-full flex gap-2 p-4 items-center justify-between cursor-pointer hover:bg-bg_text_primary/10 rounded-xl ${
        isSelected && "bg-card_bg"
      }`}
      onClick={onClick}
    >
      <div className="flex gap-2">
        <img
          className="w-[30px] h-[30px] rounded-full"
          src={chain.image}
          alt={chain.name}
        />
        <p className="text-xl capitalize font-medium text-x-purple-500">
          {chain.name}
        </p>
      </div>
      {isSelected && (
        <div className="flex gap-1 items-center">
          <LinkIcon />
          <p className="text-xs text-x-purple-500 font-bold">Selected</p>
        </div>
      )}
    </button>
  );
};
